import { Record, Map } from "immutable";
import moment from "moment";

const FormsRecord = Record({
  createSectionField: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    fields: new (Record({
      name: "",
      placeholder: "",
      value: "",
      fieldType: "",
      objectUID: null,
      sort: 1
    }))()
  }))(),
  createSectionGallery: new (Record({
    disabled: false,
    errors: new Map([]),
    isErrorVisible: new Map([]),
    isAddModalVisible: false,
    fields: new (Record({
      name: "",
      placeholder: "",
      objectUID: ""
    }))()
  }))()
});

// We can subclass FormRecord to add custom getters or methods.
export default class Forms extends FormsRecord {}



// WEBPACK FOOTER //
// ./src/common/sections/forms.js